import { IEscrowExpectedIncomingCheckData } from 'types/accounting/data/IEscrowExpectedIncomingCheckData';
import { IEscrowExpectedIncomingWireData } from 'types/accounting/data/IEscrowExpectedIncomingWireData';
import { IEscrowExpectedIncomingAchData } from 'types/accounting/data/IEscrowExpectedIncomingAchData';
import { TAddressDisplay } from './AddressDisplay';
import { IOrderData } from 'types/accounting/data/IOrderData';
import { useGetDetailedEscrowDataQuery } from 'API/order/escrow/EscrowBaseAPI';
import { ISearchOrderRequest } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface IPotentialMatch {
  expectedCheck?: IEscrowExpectedIncomingCheckData;
  expectedWire?: IEscrowExpectedIncomingWireData;
  expectedACH?: IEscrowExpectedIncomingAchData;
  expectedOrder?: ISearchOrderRequest;
}

export const useGetPotentialOrderInfo = (data: IPotentialMatch) => {
  const orderId =
    data.expectedOrder?.id ||
    data.expectedWire?.escrowFile?.order?.id ||
    data.expectedCheck?.escrowFile?.order?.id ||
    data.expectedACH?.escrowFile?.order?.id;
  const fileNumber =
    data.expectedOrder?.fileNumber ||
    data.expectedWire?.escrowFile?.order?.fileNumber ||
    data.expectedCheck?.escrowFile?.order?.fileNumber ||
    data.expectedACH?.escrowFile?.order?.fileNumber;
  const address: TAddressDisplay | undefined =
    data.expectedOrder?.propertyAddress ||
    data.expectedWire?.escrowFile?.order?.propertyAddress ||
    data.expectedCheck?.escrowFile?.order?.propertyAddress ||
    data.expectedACH?.escrowFile?.order?.propertyAddress;
  return { id: orderId, fileNumber: (fileNumber || 0), propertyAddress: address as any, parties: [] } as IOrderData;
};

export const useGetPotentialEscrowFile = (data: IPotentialMatch) => {
  const escrowFileEasy =
    data.expectedWire?.escrowFile || data.expectedCheck?.escrowFile || data.expectedACH?.escrowFile;
  const { data: escrowFile } = useGetDetailedEscrowDataQuery(data.expectedOrder?.id || '', {
    skip: !data.expectedOrder?.id,
  });
  return (
    escrowFileEasy ||
    (escrowFile && {
      id: escrowFile.id,
      depositEscrowBankAccount: escrowFile.depositEscrowBankAccount,
      createdAt: escrowFile.createdAt,
      updatedAt: escrowFile.updatedAt,
    })
  );
};
